import AllReports from "../reports/views/AllReports.vue";
import GenerateReport from "../reports/views/GenerateReport.vue";

export default [
  {
    path: "view-all",
    name: "admim-org-view-report",
    component: AllReports,
  },
  {
    path: "generate",
    name: "admim-org-generate-report",
    component: GenerateReport,
  },
];
